import React from "react"

const Bookmark = ({ width = "56", height = "68", viewBox = "0 0 56 68" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#a-bookmark)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.178 32.321h-3.107v3.108c0 1.139-.932 2.071-2.071 2.071a2.078 2.078 0 0 1-2.072-2.071V32.32h-3.107a2.077 2.077 0 0 1-2.071-2.071c0-1.14.932-2.071 2.071-2.071h3.107V25.07c0-1.139.933-2.071 2.072-2.071 1.14 0 2.071.932 2.071 2.071v3.108h3.107c1.14 0 2.072.932 2.072 2.071 0 1.14-.932 2.071-2.072 2.071ZM36.248 16H19.75A3.75 3.75 0 0 0 16 19.75v29.986c0 2.01 2.422 3.015 3.84 1.598l6.569-6.57a2.25 2.25 0 0 1 3.18 0l6.569 6.57c1.417 1.417 3.84.412 3.84-1.598V19.75A3.75 3.75 0 0 0 36.248 16Z"
          fill="#DB1616"
        />
      </g>
      <defs>
        <filter
          id="a-bookmark"
          x="-12"
          y="-6"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix values="0 0 0 0 0.558333 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default Bookmark
